// extracted by mini-css-extract-plugin
export default {"root":"ReviewsWrapper_root__mT4b2","inView":"ReviewsWrapper_inView__Ts5+O","movein":"ReviewsWrapper_movein__TcPAm"};